import * as _ from "lodash";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { StaffService } from "../../services/staff.service";

export const readStaff = createAsyncThunk(
  "staffManage/readStaff",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await StaffService.readStaff();

      return _.get(response, "data", {});
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const listStaff = createAsyncThunk(
  "staffManage/listStaff",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await StaffService.listStaff();

      return _.get(response, "data", []);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const listStaffOnline = createAsyncThunk(
  "staffManage/listStaffOnline",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await StaffService.listStaffOnline();

      return _.get(response, "data", []);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const listStaffByGroupId = createAsyncThunk(
  "staffManage/listStaffByGroupId",
  async (groupId, { rejectWithValue }) => {
    try {
      const response = await StaffService.listStaffByGroupId(groupId);

      return _.get(response, "data", []);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
